module.exports = __webpack_public_path__ + "static/media/employer-over.02362a30.svg";